// extracted by mini-css-extract-plugin
export var container = "_dy-0";
export var infoIcon = "_dy-2";
export var internalLabel = "_dy-3";
export var titleRowCol = "_dy-1";